import React from "react";

import cx from "classnames";

import RatingStars from "@components/RatingStars";

import styles from "./Rating.scss";

type RatingProps = {
  averageRating: number;
  reviewCount: number;
  showOneStar?: boolean;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  className?: string;
};

export default function Rating({
  averageRating,
  reviewCount,
  showOneStar = false,
  onClick,
  className,
}: RatingProps): JSX.Element {
  const WrapperComponent = onClick ? "button" : "div";
  return (
    <WrapperComponent
      className={cx(styles.reviewButton, className)}
      onClick={onClick}
      type="button"
      data-testid="rating-stars-wrapper"
    >
      <RatingStars
        className={styles.starsContainer}
        averageRating={averageRating}
        showOneStar={showOneStar}
      />
      <span aria-hidden="true">{averageRating.toFixed(1)}</span>
      {showOneStar || (
        <span className={styles.reviewCount}>{reviewCount} Ratings</span>
      )}
    </WrapperComponent>
  );
}
